// extracted by mini-css-extract-plugin
module.exports = {"container":"map_container__1fhkN","heading":"map_heading__2fHqm","container2":"map_container2__2M2xV","mapsection":"map_mapsection__2iQv5"};